<template>
  <div class="dynamic-table">
    <div class="table-responsive">
      <table>
        <thead>
          <tr>
            <th style="width: 45%">Forma de pago</th>
            <th style="width: 10%">Valor</th>
            <th style="width: 10%">Plazo</th>
            <th style="width: 15%">Unidad de tiempo</th>
            <th style="width: 3%" class="ta-right">
              <button
                @click="agregarFormaPago"
                class="btn-success"
                type="button"
              >
                <i class="fa fa-plus"></i>
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in value" :key="index">
            <td>
              <div class="select2-field select2--readonly">
                <v-select
                  :tooltip="
                    row.selectedFormaPago !== undefined &&
                    row.selectedFormaPago !== null &&
                    row.selectedFormaPago.nombre !== ''
                      ? row.selectedFormaPago.nombre
                      : 'Seleccione...'
                  "
                  label="nombre"
                  :options="formasPago"
                  v-model="row.selectedFormaPago"
                  :id="'formaPago' + index"
                  placeholder="Seleccione..."
                ></v-select>
                <span
                  v-if="
                    erroresFormulario.hasOwnProperty(
                      'formasPago.' + index + '.selectedFormaPago.id_forma_pago'
                    )
                  "
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{
                    erroresFormulario[
                      "formasPago." + index + ".selectedFormaPago.id_forma_pago"
                    ][0]
                  }}</strong>
                </span>
              </div>
            </td>
            <td>
              <input-field
                @keyup.native="$emit('updatedFormaPago')"
                vMoney
                :format="money"
                v-model="row.valor"
                :id="'valor' + index"
                placeholder="$ #,###.##"
                readonly
              >
                <span
                  v-if="
                    erroresFormulario.hasOwnProperty(
                      'formasPago.' + index + '.valor'
                    )
                  "
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{
                    erroresFormulario["formasPago." + index + ".valor"][0]
                  }}</strong>
                </span>
              </input-field>
            </td>
            <td>
              <input-field
                @keyup.native="$emit('updatedFormaPago')"
                vMoney
                :format="int"
                v-model="row.plazo"
                :id="'plazo' + index"
                placeholder="Plazo de pago"
                readonly
              >
                <span
                  v-if="
                    erroresFormulario.hasOwnProperty(
                      'formasPago.' + index + '.plazo'
                    )
                  "
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{
                    erroresFormulario["formasPago." + index + ".plazo"][0]
                  }}</strong>
                </span>
              </input-field>
            </td>
            <td>
              <div class="select2-field select2--readonly">
                <v-select
                  @input="$emit('updatedFormaPago')"
                  :tooltip="
                    row.unidad_tiempo !== ''
                      ? row.unidad_tiempo
                      : 'Seleccione...'
                  "
                  :id="'unidadTiempo' + index"
                  placeholder="Seleccione..."
                  :options="tiposUnidad"
                  v-model="row.unidad_tiempo"
                ></v-select>
                <span
                  v-if="
                    erroresFormulario.hasOwnProperty(
                      'formasPago.' + index + '.unidad_tiempo'
                    )
                  "
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{
                    erroresFormulario[
                      "formasPago." + index + ".unidad_tiempo"
                    ][0]
                  }}</strong>
                </span>
              </div>
            </td>
            <td>
              <div class="d-flex jc-right gap-10">
                <button
                  class="btn-info btn--text-outline"
                  @click="editarFormaPago(index)"
                  type="button"
                >
                  <i class="fa fa-edit"></i>
                </button>
                <button
                  :disabled="disabled"
                  @click="eliminarFormaPago(index)"
                  class="btn-danger btn--text-outline"
                  type="button"
                >
                  <i class="fa fa-trash-o"></i>
                </button>
              </div>
            </td>
          </tr>
          <tr>
            <td v-show="modelValue.length === 0" colspan="5">
              <strong>No se ha agregado forma de pago alguna.</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <dynamic-table
      title="Forma de pago"
      v-show="isDynamicTableVisible"
      @close="closeDynamicTable"
      :value="selectedItem"
    >
      <template #default="{ selectedRow }">
        <div :class="{ 'select2--disabled': disabled }" class="select2-field">
          <v-select
            :tooltip="
              selectedRow.selectedFormaPago !== undefined &&
              selectedRow.selectedFormaPago !== null &&
              selectedRow.selectedFormaPago.nombre !== ''
                ? selectedRow.selectedFormaPago.nombre
                : 'Seleccione...'
            "
            label="nombre"
            :options="formasPago"
            v-model="selectedRow.selectedFormaPago"
            :id="'formaPago'"
            placeholder="Seleccione..."
          ></v-select>
          <label for="formPago">Forma de pago</label>
          <span
            v-if="
              erroresFormulario.hasOwnProperty(
                'formasPago.selectedFormaPago.id_forma_pago'
              )
            "
            class="helper-text text-danger"
            slot="helper"
          >
            <strong>{{
              erroresFormulario["formasPago.selectedFormaPago.id_forma_pago"][0]
            }}</strong>
          </span>
        </div>
        <input-field
          @keyup.native="$emit('updatedFormaPago')"
          :disabled="disabled"
          vMoney
          :format="money"
          v-model="selectedRow.valor"
          :id="'valor'"
          placeholder="$ #,###.##"
        >
          <span>Valor</span>
          <span
            v-if="erroresFormulario.hasOwnProperty('formasPago.valor')"
            class="helper-text text-danger"
            slot="helper"
          >
            <strong>{{ erroresFormulario["formasPago.valor"][0] }}</strong>
          </span>
        </input-field>
        <input-field
          @keyup.native="$emit('updatedFormaPago')"
          :disabled="disabled"
          vMoney
          :format="int"
          v-model="selectedRow.plazo"
          :id="'plazo'"
          placeholder="Plazo de pago"
        >
          <span>Plazo</span>
          <span
            v-if="erroresFormulario.hasOwnProperty('formasPago.plazo')"
            class="helper-text text-danger"
            slot="helper"
          >
            <strong>{{ erroresFormulario["formasPago.plazo"][0] }}</strong>
          </span>
        </input-field>
        <div :class="{ 'select2--disabled': disabled }" class="select2-field">
          <v-select
            @input="$emit('updatedFormaPago')"
            :tooltip="
              selectedRow.unidad_tiempo !== ''
                ? selectedRow.unidad_tiempo
                : 'Seleccione...'
            "
            :id="'unidadTiempo'"
            placeholder="Seleccione..."
            :options="tiposUnidad"
            v-model="selectedRow.unidad_tiempo"
          ></v-select>
          <label for="unidadTiempo">Unidad de tiempo</label>
          <span
            v-if="erroresFormulario.hasOwnProperty('formasPago.unidad_tiempo')"
            class="helper-text text-danger"
            slot="helper"
          >
            <strong>{{
              erroresFormulario["formasPago.unidad_tiempo"][0]
            }}</strong>
          </span>
        </div>
      </template>
    </dynamic-table>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: function() {
        return [];
      },
      required: false,
    },
    formasPago: {
      required: true,
      type: Array,
    },
    errores: {
      type: Object,
      required: true,
    },
    totalComprobante: {
      required: true,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    tiposUnidad: {
      required: true,
      type: Array,
    },
    formaPagoIdDefault: {
      required: false,
      type: String,
      default: null,
    },
  },
  data: function() {
    return {
      modelValue: this.value,
      erroresFormulario: this.errores,
      money: money,
      int: int,
      isDynamicTableVisible: false,
      selectedItem: {
        plazo: "",
        selectedFormaPago: null,
        unidad_tiempo: "",
        valor: "",
      },
    };
  },
  methods: {
    agregarFormaPago: function() {
      this.modelValue.push({
        selectedFormaPago: null,
        valor: "",
        plazo: "",
        unidad_tiempo: "",
      });
    },
    eliminarFormaPago: function(index) {
      let that = this;
      swal({
        title: "¿Desear eliminar esta forma de pago?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) that.modelValue.splice(index, 1);
        that.$emit("updatedFormaPago");
      });
    },
    editarFormaPago: function(index) {
      this.selectedItem = this.modelValue[index];
      this.isDynamicTableVisible = true;
    },
    closeDynamicTable: function() {
      this.isDynamicTableVisible = false;
    },
  },
  watch: {
    value: function(value) {
      this.modelValue = value;
    },
    errores: function(value) {
      this.erroresFormulario = value;
    },
    totalComprobante: function(value) {
      if (this.modelValue.length === 0) {
        this.modelValue.push({
          selectedFormaPago: null,
          valor: value,
          plazo: 0,
          unidad_tiempo: "días",
        });
      } else if (this.modelValue.length === 1) {
        let formaPago = this.modelValue[0];
        if (formaPago.selectedFormaPago === null) {
          let selectedFormapago = null;
          for (let i = 0; i < this.formasPago.length; i++){
            if(this.formaPagoIdDefault && this.formasPago[i].id_forma_pago == this.formaPagoIdDefault){
              selectedFormapago = this.formasPago[i];
              break;
            }
            else if (this.formasPago[i].id_forma_pago === "01") {
              selectedFormapago = this.formasPago[i];
              break;
            }
          }
          formaPago.selectedFormaPago = selectedFormapago;
        }
        formaPago.valor = value;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/TablaFormaPago.vue